const VERBOSE_LANGUAGES = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
  pt: 'Portuguese',
  fr: 'French',
  it: 'Italian',
  nl: 'Dutch',
  pt_br: 'Brazilian Portuguese',
  id: 'Indonesian',
  mn: 'Mongolian',
  ar: 'Arabic',
  bn: 'Bengali',
  hi: 'Hindi',
  ru: 'Russian',
  th: 'Thai',
  vi: 'Vietnamese',
  kh: 'Khmer',
  sw: 'Swahili',
  ca: 'Catalan',
  da: 'Danish',
  el: 'Greek',
  fa: 'Persian',
  fi: 'Finnish',
  ga: 'Irish',
  he: 'Hebrew',
  hr: 'Croatian',
  hu: 'Hungarian',
  ja: 'Japanese',
  nb: 'Norwegian Bokmål',
  pl: 'Polish',
  ro: 'Romanian',
  si: 'Sinhala',
  sv: 'Swedish',
  te: 'Telugu',
  tr: 'Turkish',
  tt: 'Tatar',
  ur: 'Urdu',
  zh: 'Chinese',
  ha: 'Hausa',
  ka: 'Georgian',
  kk: 'Kazakh',
  sq: 'Albanian',
  hy: 'Armenian',
  az: 'Azerbaijani',
  be: 'Belarusian',
  bs: 'Bosnian',
  bg: 'Bulgarian',
  cs: 'Czech',
  ky: 'Kyrgyz',
  mk: 'Macedonian',
  sr: 'Serbian',
  uk: 'Ukrainian',
  uz: 'Uzbek',
  ab: 'Abkhazian',
  aa: 'Afar',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  an: 'Aragonese',
  as: 'Assamese',
  av: 'Avaric',
  ae: 'Avestan',
  ay: 'Aymara',
  bm: 'Bambara',
  ba: 'Bashkir',
  eu: 'Basque',
  bh: 'Bihari languages',
  bi: 'Bislama',
  br: 'Breton',
  my: 'Burmese',
  ch: 'Chamorro',
  ce: 'Chechen',
  ny: 'Chichewa',
  kw: 'Cornish',
  cv: 'Chuvash',
  co: 'Corsican',
  cr: 'Cree',
  dv: 'Divehi',
  dz: 'Dzongkha',
  eo: 'Esperanto',
  et: 'Estonian',
  ee: 'Ewe',
  fo: 'Faroese',
  fj: 'Fijian',
  ff: 'Fulah',
  gl: 'Galician',
  gu: 'Gujarati',
  ht: 'Haitian',
  hz: 'Herero',
  ho: 'Hiri Motu',
  ia: 'Interlingua',
  ie: 'Interlingue',
  ig: 'Igbo',
  ik: 'Inupiaq',
  io: 'Ido',
  is: 'Icelandic',
  iu: 'Inuktitut',
  jv: 'Javanese',
  kl: 'Kalaallisut',
  kn: 'Kannada',
  kr: 'Kanuri',
  ks: 'Kashmiri',
  km: 'Central Khmer',
  ki: 'Kikuyu',
  rw: 'Kinyarwanda',
  kv: 'Komi',
  kg: 'Kongo',
  ko: 'Korean',
  ku: 'Kurdish',
  kj: 'Kuanyama',
  la: 'Latin',
  lb: 'Luxembourgish',
  lg: 'Ganda',
  li: 'Limburgan',
  ln: 'Lingala',
  lo: 'Lao',
  lt: 'Lithuanian',
  lu: 'Luba-Katanga',
  lv: 'Latvian',
  gv: 'Manx',
  mg: 'Malagasy',
  ms: 'Malay',
  ml: 'Malayalam',
  mt: 'Maltese',
  mi: 'Maori',
  mr: 'Marathi',
  mh: 'Marshallese',
  na: 'Nauru',
  nv: 'Navajo',
  nd: 'North Ndebele',
  ne: 'Nepali',
  ng: 'Ndonga',
  nn: 'Norwegian Nynorsk',
  no: 'Norwegian',
  ii: 'Sichuan Yi',
  nr: 'South Ndebele',
  oc: 'Occitan',
  oj: 'Ojibwa',
  cu: 'Church Slavic',
  om: 'Oromo',
  or: 'Oriya',
  os: 'Ossetian',
  pa: 'Punjabi',
  pi: 'Pali',
  ps: 'Pashto',
  qu: 'Quechua',
  rm: 'Romansh',
  rn: 'Rundi',
  sa: 'Sanskrit',
  sc: 'Sardinian',
  sd: 'Sindhi',
  se: 'Northern Sami',
  sm: 'Samoan',
  sg: 'Sango',
  gd: 'Gaelic',
  sn: 'Shona',
  sk: 'Slovak',
  sl: 'Slovenian',
  so: 'Somali',
  st: 'Southern Sotho',
  su: 'Sundanese',
  ss: 'Swati',
  ta: 'Tamil',
  tg: 'Tajik',
  ti: 'Tigrinya',
  bo: 'Tibetan',
  tk: 'Turkmen',
  tl: 'Tagalog',
  tn: 'Tswana',
  to: 'Tonga',
  tw: 'Twi',
  ty: 'Tahitian',
  ug: 'Uighur',
  ve: 'Venda',
  vo: 'Volapük',
  wa: 'Walloon',
  cy: 'Welsh',
  wo: 'Wolof',
  fy: 'Western Frisian',
  xh: 'Xhosa',
  yi: 'Yiddish',
  yo: 'Yoruba',
  za: 'Zhuang',
  zu: 'Zulu',
};

export default VERBOSE_LANGUAGES;
